import React from 'react';
import { ArrowLeft } from 'lucide-react';

interface ReportEditBackLinkProps {
  onBack: () => void;
}

export const ReportEditBackLink: React.FC<ReportEditBackLinkProps> = ({ onBack }) => (
  <div className="flex items-center gap-2 mb-6">
    <button
      type="button"
      onClick={onBack}
      className="flex items-center gap-2 cursor-pointer text-sm text-gray-600 hover:text-gray-900 transition-colors"
    >
      <ArrowLeft className="w-4 h-4" />
      Voltar
    </button>
  </div>
);
